module.exports = __webpack_public_path__ + "img/logo.c9dd96d7.png";